<template>
  <div class="about pb-5">
    <app-banner/>
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="subject">
            <header class="text-right">
              <i class="flaticon-note icon-20"></i>
              <h3>درباره مادیا</h3>
            </header>
          </div>
        </div>
      </div>
      <b-card no-body>
        <b-tabs center pills card v-model="tabIndex">
          <b-tab title="درباره ما">
            <div class="about-content">
              <p>
                مادیا یک پلتفر م و بازارچه آموزشی آنلاین است، که به کاربرانش کمک میکند، فارغ از زمان و مکان، هم آموزش ببینند
                و هم آموزش بدهند، ما این امکان را با ارائه زیرساخت های لازم در قالب یک پلتفرم نرم افزای تحت وب (سایت مادیا) ارائه میدهیم،
                در این پلتفرم ابزارهای ساخت
                و مدیریت دوره در اختیار مدرسین و آموزشگاه ها قرار می گیرد و مخاطبین (دانش پژوهان) نیز می توانند به بهترین دوره های آموزشی،
                در هر زمان و مکانی دسترسی و بصورت آنلاین مشاهده نمایند.
              </p>
            </div>
          </b-tab>
          <b-tab title="مادیا در رسانه">
            <div class="about-content">
              <div class="about-media">
                <p>
                  <img src="../../static/img/ictstartups.png" alt>
                  مرکز توانمندسازی و تسهیل گری کسب و کارهای نوپای فاوا : مصاحبه با استارت آپ پلتفرم آموزش های آنلاین مادیا
                  <a
                    href="http://www.ictstartups.ir/fa/content/56093"
                  >مشاهده</a>
                </p>
                <p>
                  <img src="../../static/img/inet.png" alt>
                  آینت : مصاحبه با استارت آپ پلتفرم آموزش‌های آنلاین با استارت‌آپ مادیا
                  <a
                    href="http://www.inet.ir/v/ZBd3AQ"
                  >مشاهده</a>
                </p>
                <p>
                  <img src="../../static/img/danseshjo.png" alt>
                  خبرگزاری دانشجو : «مادیا» پل ارتباطی مدرسان و مخاطبان/ مهارت‌های خود را در بزرگترین بازار آموزش کشور تقویت کنید.
                  <a
                    href="http://snn.ir/0032Vj"
                  >مشاهده</a>
                </p>
                <p>
                  <img src="../../static/img/civil808.png" alt>
                  موسسه آموزشی مهندسی 808 : معرفی سایت مادیا
                  <a
                    href="https://civil808.com/news/19843/%D8%B1%D9%BE%D9%88%D8%B1%D8%AA%D8%A7%DA%98-%D8%A2%DA%AF%D9%87%DB%8C-%D9%85%D8%B9%D8%B1%D9%81%DB%8C-%D8%B3%D8%A7%DB%8C%D8%AA-%D9%85%D8%A7%D8%AF%DB%8C%D8%A7"
                  >مشاهده</a>
                </p>
              </div>
            </div>
          </b-tab>
          <b-tab title="تماس باما">
            <div class="about-content">
              <div class="row">
                <div class="col-md-6">
                  <ul class="about-adress">
                    <li>
                      <p>
                        <i class="flaticon-map"></i>
                        تهران - سعادت آباد - خيابان سرو غربي - ابتداي خيابان بخشايش - پلاك ۳۷ - طبقه اول - واحد۳
                      </p>
                    </li>

                    <li>
                      <p>
                        <i class="flaticon-phone-call"></i>
                        <a href="tel:021-22094720">021-22094720</a>
                      </p>
                    </li>

                    <li>
                      <p>
                        <i class="flaticon-mail"></i>
                        <a href="mailto:madya.oce@gmail.com"  target="_blank">madya.oce@gmail.com</a>
                      </p>
                    </li>
                    <li>
                      <p>
                        <i class="flaticon-telegram"></i>
                        <a href="https://t.me/madya_ir" target="_blank">@madya_ir</a>
                      </p>
                    </li>
                    <li>
                      <p>
                        <i class="flaticon-telegram"></i>
                        <a href="http://t.me/madya_support" target="_blank">@madya_support</a>
                      </p>
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <div class="subject pt-0">
                    <header class="text-right">
                      <i class="flaticon-mail icon-20"></i>
                      <h3>ارسال پیام به مادیا</h3>
                    </header>
                  </div>
                  <form class="row" @submit.prevent>
                    <div class="col-lg-6 col-12">
                      <div class="group-form">
                        <input
                          type="text"
                          name="ایمیل"
                          :class="{active:form.sender != ''}"
                          v-model="form.sender"
                          v-validate="'required|email'"
                        >
                        <span class="bar"></span>
                        <label>ایمیل</label>
                        <span v-if="errors.has('ایمیل')" class="is-danger">{{errors.first('ایمیل')}}</span>
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="group-form">
                        <input
                          type="text"
                          name="نام شما"
                          :class="{active:form.name != ''}"
                          v-model="form.name"
                          v-validate="'required'"
                        >
                        <span class="bar"></span>
                        <label>نام شما</label>
                        <span
                          v-if="errors.has('نام شما')"
                          class="is-danger"
                        >{{errors.first('نام شما')}}</span>
                      </div>
                    </div>
                    <div class="col-lg-12 col-12">
                      <div class="group-form">
                        <input
                          type="text"
                          name="موضوع"
                          :class="{active:form.subject != ''}"
                          v-model="form.subject"
                          v-validate="'required'"
                        >
                        <span class="bar"></span>
                        <label>موضوع</label>
                        <span v-if="errors.has('موضوع')" class="is-danger">{{errors.first('موضوع')}}</span>
                      </div>
                    </div>
                    <div class="col-lg-12 col-12">
                      <div class="group-form">
                        <textarea
                          v-validate="'required'"
                          name="پیام"
                          :class="{active:form.body != ''}"
                          v-model="form.body"
                        ></textarea>
                        <span class="bar"></span>
                        <label>پیام شما</label>
                        <span v-if="errors.has('پیام')" class="is-danger">{{errors.first('پیام')}}</span>
                      </div>
                    </div>
                    <!-- <div class="col-md-12"> -->
                    <!-- <vue-recaptcha sitekey="Your key here"></vue-recaptcha> -->
                    <!-- <vue-recaptcha sitekey="6Lfza5MUAAAAAGD1mu2hcefohkojqHiit6CrTz6F"></vue-recaptcha> -->
                    <!-- <vue-recaptcha sitekey="6LcmbJMUAAAAAGggxbkYjf9Jhq8fzU0LwJHWXxD_"/> -->
                    <!-- <vue-recaptcha sitekey="6LcmbJMUAAAAAGggxbkYjf9Jhq8fzU0LwJHWXxD_"></vue-recaptcha> -->
                    <!-- </div> -->
                    <div class="col-md-12">
                      <div class="form-action form-action-left">
                        <button
                          @click="sendMsg()"
                          class="text-center bttn-material-flat bttn bttn-primary margin-20"
                          v-ripple
                        >ارسال</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import AppBanner from "cp/banner.vue";
// import VueRecaptcha from 'vue-recaptcha';
export default {
  name: "about",
  components: {
    AppBanner,
  },
  data() {
    return {
      tabIndex: 0,
      form: {
        body: '',
        subject: '',
        sender: '',
        name: ''

      }
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      if (this.$route.query && this.$route.query.tabActive) {
        this.tabIndex = parseInt(this.$route.query.tabActive);
      }
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.tabActive) {
      this.tabIndex = parseInt(this.$route.query.tabActive);
    }
  },
  methods: {
    // onSubmit: function () {
    //   this.$refs.invisibleRecaptcha.execute()
    // },
    onVerify: function (response) {
      console.log('Verify: ' + response)
    },
    onExpired: function () {
      console.log('Expired')
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
    async   sendMsg() {
      let result = await this.$validator.validate()
      if (result) {
        this.$store.dispatch('sendMsg', this.form)
        this.form = {
          body: '',
          subject: '',
          sender: '',
          name: ''

        }
        this.$validator.reset();
      } else {
        this.$root.showWarnMsg({
          message: 'لطفا فرم را تکمیل کنید ... '
        })
      }
    }
  }

};
</script>

<style lang="less" >
@import (reference) "../assets/css/variable.less";
a {
  color: @green;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: @green !important;
}
.about {
  .nav {
    justify-content: center;
  }
  &-content {
    padding: 0 15px;
    p {
      font-size: 16px;
      text-align: justify;
      color: #010101;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  &-adress {
    display: flex;
    flex-direction: column;
    li {
      p {
        a {
          display: inline-block;
          direction: ltr;
        }
      }
      i {
        display: inline-block;
        direction: rtl;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue